import { useEffect, useRef } from 'react';
export function useAlertTimer({ duration = 0, onClose }) {
    const timerRef = useRef(null);
    useEffect(() => {
        if (duration && duration >= 1 && onClose) {
            timerRef.current = setTimeout(onClose, duration * 1000);
            return () => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                }
            };
        }
    }, [duration, onClose]);
    return {
        timerRef,
    };
}
